import { render, staticRenderFns } from "./newTransactions.vue?vue&type=template&id=4c276ef1&"
import script from "./newTransactions.vue?vue&type=script&lang=js&"
export * from "./newTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports